import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'
import Box from 'components/shared/Box'

export const PriceWrapper = styled(Box)`
    @media ${respondAbove.xs} {
        min-width: 90px;
    }
`
